import { render, staticRenderFns } from "./PageFoodDiarySkeleton.vue?vue&type=template&id=0271c549&scoped=true"
import script from "./PageFoodDiarySkeleton.vue?vue&type=script&lang=js"
export * from "./PageFoodDiarySkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271c549",
  null
  
)

export default component.exports